import { NgModule, isDevMode, Component } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicModule } from '@ionic/angular';
import { OfflineComponent } from './offline/offline.component';
import { ServiceWorkerModule } from '@angular/service-worker';

// Minimal shell used when backend / OAuth endpoints are unreachable at startup.
// Avoids loading ABP & OAuth initializers that trigger network calls and cause blank screen.
// We cannot bootstrap a standalone component directly from an NgModule (NG6009),
// so we create a simple wrapper component hosting the standalone OfflineComponent.

@Component({
	selector: 'app-root',
	template: `
    <ion-app>
      <div style="padding:2rem;text-align:center;color:#ee2737;font-size:1.2rem;">[OfflineShellModule loaded]</div>
      <app-offline></app-offline>
    </ion-app>
  `,
	standalone: false
})
class OfflineRootWrapperComponent { }
@NgModule({
	declarations: [OfflineRootWrapperComponent],
	imports: [
		BrowserModule,
		IonicModule.forRoot({ innerHTMLTemplatesEnabled: true }),
		OfflineComponent,
		ServiceWorkerModule.register('ngsw-worker.js', {
			enabled: !isDevMode(),
			registrationStrategy: 'registerWhenStable:30000'
		})
	],
	bootstrap: [OfflineRootWrapperComponent]
})
export class OfflineShellModule { }
